import HCLDX from "@system/config/hcldx";
import System from "src/helper/system";

class ProductCompare {
    static getProductComparePageRouteURL() {
        return HCLDX.baseURL() + '/products/product-compare';
    }
}

export default ProductCompare;